const update = () => {
  const params = new URLSearchParams(window.location.search);
  const category = params.get('category');
  const filter = params.get('filter.p.m.custom.categories');

  document.querySelectorAll('[data-category-context-input]').forEach((input) => {
    input.value = category || '';
    input.disabled = !category;
  });

  document.querySelectorAll('[data-category-filter-context-input]').forEach((input) => {
    input.value = filter || '';
    input.disabled = !filter;
  });

  document.querySelectorAll('[data-product-context-link]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    if (category) url.searchParams.set('category', category);
    else url.searchParams.delete('category');
    link.href = `${url.pathname}${url.search}${url.hash}`;
  });

  document.querySelectorAll('[data-explore-category]').forEach((card) => {
    const isSelected = card.dataset.exploreCategory === category || card.dataset.exploreCategoryFilter === filter;
    card.hidden = isSelected;
  });

  const productListCategoryOption = [...document.querySelectorAll('[data-product-list-category-option]')]
    .find((option) => option.dataset.categoryHandle === category);
  const productListCollectionBreadcrumb = document.querySelector('[data-product-list-collection-breadcrumb]');
  const productListCategorySeparator = document.querySelector('[data-product-list-category-separator]');
  const productListCategoryBreadcrumb = document.querySelector('[data-product-list-category-breadcrumb]');
  if (productListCategoryOption && productListCategoryBreadcrumb) {
    if (productListCollectionBreadcrumb) productListCollectionBreadcrumb.hidden = false;
    if (productListCategorySeparator) productListCategorySeparator.hidden = false;
    if (productListCategoryBreadcrumb.textContent !== productListCategoryOption.dataset.categoryTitle) {
      productListCategoryBreadcrumb.textContent = productListCategoryOption.dataset.categoryTitle;
    }
  }

  const categoryLink = document.querySelector('[data-breadcrumb-category-link]');
  const categoryItem = document.querySelector('[data-breadcrumb-category-item]');
  const categorySeparator = document.querySelector('[data-breadcrumb-category-separator]');
  const categoryOption = [...document.querySelectorAll('[data-breadcrumb-category-option]')]
    .find((option) => option.dataset.categoryHandle === category);
  if (categoryLink && categoryOption) {
    const collectionUrl = categoryLink.dataset.collectionUrl;
    const categoryUrl = new URL(collectionUrl, window.location.origin);
    categoryUrl.searchParams.set('category', categoryOption.dataset.categoryHandle);
    categoryUrl.searchParams.set('filter.p.m.custom.categories', categoryOption.dataset.categoryFilter);
    categoryLink.href = `${categoryUrl.pathname}${categoryUrl.search}`;
    if (categoryLink.textContent !== categoryOption.dataset.categoryTitle) {
      categoryLink.textContent = categoryOption.dataset.categoryTitle;
    }
    if (categoryItem) categoryItem.hidden = false;
    categoryLink.hidden = false;
    if (categorySeparator) categorySeparator.hidden = false;
  }
};

update();
new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
window.addEventListener('popstate', update);
